export const UNCONFIRMED_ERROR = 'Your email is not confirmed';
